import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
// import editor from "../../Assets/Projects/codeEditor.png";
// import chatify from "../../Assets/Projects/chatify.png";
// import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"chatify"}
              isBlog={false}
              title="Marketplace Project"
              description="Digital Marketplace project build React.js, Node.js, Express, Material-UI, and MongoDB. Have features which allows user for realtime messaging."
              // ghLink="https://github.com/soumyajit4419/Chatify"
              //demoLink="https://chatify-49.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              // imgPath={"bitsOfCode"}
              isBlog={false}
              title="Attendace Management System"
              description="This is simpe porject fro attendance management system build wiht C# and sql."
              ghLink="https://github.com/kheyrem/Attendance-management-system"
              // demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              // imgPath={"editor"}
              isBlog={false}
              title="Expense Tracker"
              description="Expense Tracker prject build with ejs, Node.js and MongoDB"
              ghLink="https://github.com/kheyrem/expTracker-"
              // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              // imgPath={"editor"}
              isBlog={false}
              title="Portfolio website"
              description="portfolio website build with React.js, Node.js, express and MongoDB"
              ghLink="https://github.com/kheyrem/PortfolioWebsite"
              // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              // imgPath={"editor"}
              isBlog={false}
              title="Book store"
              description="book store website build with React.js, Node.js, express and MongoDB"
              ghLink="https://github.com/kheyrem/BookStoreWebApp"
              // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>
           
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
